import { render } from "./KontaktPage.vue?vue&type=template&id=e0dc99b2&scoped=true"
import script from "./KontaktPage.vue?vue&type=script&lang=js"
export * from "./KontaktPage.vue?vue&type=script&lang=js"

import "./KontaktPage.vue?vue&type=style&index=0&id=e0dc99b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0dc99b2"]])

export default __exports__